
import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "cashReturnList",
})
export default class cashReturnList extends Vue {
  private tableData: Array<any> = [];
  private pageNo = 1;
  private pageSize = 10;
  private form = {};
  private totalNum = 0;
  
  data() {
        return {
          options1: [{
            value1: '选项1',
            label1: '微信支付'
          }, {
            value1: '选项2',
            label1: '支付宝支付'
          }, {
            value1: '选项3',
            label1: '余额支付'
          }, {
            value1: '选项4',
            label1: '组合支付'
          }],
          value1: '',
		  options2: [{
		    value2: '选项1',
		    label2: '待发货'
		  }, {
		    value2: '选项2',
		    label2: '已发货'
		  }, {
		    value2: '选项3',
		    label2: '待品测'
		  }, {
		    value2: '选项4',
		    label2: '已完成'
		  }],
		  value2: ''
        }
    }

  private get pagedTableData() {
	  
    return this.tableData.filter(
      (v, i) =>
        i >= (this.pageNo - 1) * this.pageSize &&
        i <= this.pageNo * this.pageSize - 1
    );
  }

  private mounted() {
    
	this.getOrderList(1);
  }
  
  private getOrderList(num:any){
	  
	let datas = [];
	this.pageNo = num;
	let paramter = {
		'pageNum':this.pageNo,
		'pageSize':this.pageSize,
		'status' : 5
	};
	this.$http.get("order/list", {params:paramter}).then((res: any) => {
		this.totalNum = res.data.data.total;
		datas = res.data.data.data;
				this.pageNo = num;
				this.pageSize = res.data.data.pageSize;
		this.tableData = datas;
		this.tableData = this.tableData.map(item=>{
			// item.enable = item.enable == 1?true:false;
			item.tasteCount = item.tasteVos.length;
			return item;
		});
		
	});
  }

  private handleSizeChange(val: number) {
    console.log(`每页 ${val} 条`);
    this.pageSize = val;
    this.pageNo = 1;
  }

  private handleCurrentChange(val: number) {
    console.log(`当前页: ${val}`);
    this.pageNo = val;
	this.getOrderList(this.pageNo);
  }
  private onSubmit() {
    console.log(this.form);
  }
  private handleDetail(index,row){
  	  
  	  console.log(row);
	  this.$router.push( {
	                path: '/Firm',  //路由
	                name: 'orderDetail',    //页面
	                params: row
				})
  }
}
